import { NavigateFunction } from 'react-router-dom'

let navigate: NavigateFunction | null = null

export const setGlobalNavigate = (navFn: NavigateFunction): void => {
    navigate = navFn
}

export const navigateTo = (path: string, options?: { replace?: boolean; state?: object }): void => {
    if (navigate) {
        navigate(path, options)
    }
}
